module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3yO8i"))).then(() => parcelRequire('d0iPb'));